import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { useTipoEtiqueta } from "../hooks/useTipoEtiqueta";
import { usePesoEnvase } from "../hooks/usePesoEnvase";
import { useTipoCaja } from "../hooks/useTipoCaja";
import { useEtiqueta } from "../hooks/useEtiqueta";
import { useBultosPalet } from "../hooks/useBultosPalet";
import { useState } from "react";
import { useYeguere } from "../hooks/useYeguere";
import { TIPO_PEDIDO } from "../constants/Empaque.Constants";
import { useDestinoInmediato } from "../hooks/useDestinoInmediato";
import { useDestino } from "../hooks/useDestino";
import { useTarimas } from "../hooks/useTarimas";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSugerencia } from "../../../features/catalogo/sugerencia_empaque/hooks/useSugerencia";

const TIPO_ETIQUETA_SLUG = {
  Convencional: "CV",
  Orgánico: "ORG",
};

export const PedidoForm = ({
  tamaniosOptions,
  variedadOptions,
  id_cultivo,
  values,
  errors,
  touched,
  handleSubmit,
  handleChange,
  setFieldValue,
  isVisible,
  onClose,
  isEditing,
  isLoading,
}) => {
  const [restante, setRestante] = useState(0);
  const [selectedSugerenciaId, setSelectedSugerenciaId] = useState(null);
  const { tipoEtiqueta } = useTipoEtiqueta();
  const { pesoEnvase } = usePesoEnvase(id_cultivo);
  const { tipoCaja } = useTipoCaja(values.id_peso_envase);
  const { etiquetas } = useEtiqueta(
    values.id_tipo_caja,
    values.id_tipo_etiqueta,
  );
  const { butlosPalet } = useBultosPalet(values.id_tipo_caja);
  const { yeguere } = useYeguere();
  const { destinoInmediato } = useDestinoInmediato();
  const { destino } = useDestino();
  const { tarimas } = useTarimas();
  const { sugerencias } = useSugerencia(true);

  const handleSave = () => {
    handleSubmit();
    setSelectedSugerenciaId(null);
  };

  const handleGuardarConPrioridadClick = () => {
    setFieldValue("prioridad", true);
    handleSubmit();
    setSelectedSugerenciaId(null);
  };

  const handleSelectSize = (size, value) => {
    setFieldValue("calibre", size);
    setFieldValue("total", value);
    setFieldValue("id_tipo_etiqueta", 0);
    setFieldValue("id_peso_envase", 0);
    setFieldValue("id_tipo_caja", 0);
    setFieldValue("id_etiqueta", 0);
    setFieldValue("id_bultos_por_palet", 0);
    setFieldValue("bultos_por_palet", 0);
    setFieldValue("cantidad_palet", 0);
    setFieldValue("resto", false);
    setFieldValue("limite", 0);
  };

  const handleSelectPesoEnvase = (id_peso_envase) => {
    setFieldValue("id_peso_envase", id_peso_envase);
    setFieldValue("id_tipo_caja", 0);
    setFieldValue("id_etiqueta", 0);
    setFieldValue("id_bultos_por_palet", 0);
    setFieldValue("bultos_por_palet", 0);
    setFieldValue("cantidad_palet", 0);
    setFieldValue("resto", false);
    setFieldValue("limite", 0);
  };

  const handleSelectTipoCaja = (id_tipo_caja) => {
    setFieldValue("id_tipo_caja", id_tipo_caja);
    setFieldValue("id_etiqueta", 0);
    setFieldValue("id_bultos_por_palet", 0);
    setFieldValue("bultos_por_palet", 0);
    setFieldValue("cantidad_palet", 0);
    setFieldValue("resto", false);
    setFieldValue("limite", 0);
  };

  const handleSelectEtiqueta = (id_etiqueta) => {
    setFieldValue("id_etiqueta", id_etiqueta);
    setFieldValue("id_bultos_por_palet", 0);
    setFieldValue("bultos_por_palet", 0);
    setFieldValue("cantidad_palet", 0);
    setFieldValue("resto", false);
    setFieldValue("limite", 0);
  };

  const handleRestoChange = (e) => {
    const selected_size = tamaniosOptions.find(
      (item) => item.tamanio === values.calibre,
    );
    const checked = e.target.checked;
    setFieldValue("resto", checked);
    setFieldValue("limite", 0);
    if (selected_size && checked) {
      const total = Math.ceil(selected_size.total / values.bultos_por_palet);
      setFieldValue("cantidad_palet", total);
      setRestante(0);
    }
  };

  const handleSelectBultosPorPalet = (id_palet, bultos_por_palet) => {
    setFieldValue("id_bultos_por_palet", id_palet);
    setFieldValue("bultos_por_palet", bultos_por_palet);
    setFieldValue("cantidad_palet", 0);
    setFieldValue("resto", false);
    setFieldValue("limite", 0);
    setRestante(0);
  };

  const handleCantidadPaletChangeHandler = (event) => {
    const cantidad = event.target.value;
    setFieldValue("cantidad_palet", cantidad);
    const selected_size = tamaniosOptions.find(
      (item) => item.tamanio === values.calibre,
    );

    if (Number(cantidad) && Number(cantidad) !== 0 && selected_size) {
      const total = Number(cantidad) * Number(values.bultos_por_palet);
      const resto = selected_size.total - total;
      if (values.bicolor) {
        const palets_repartidos = total / values.variedad_bicolor.length;

        for (const variedad of values.variedad_bicolor) {
          const size_selected = variedad.tamanios.find(
            (item) => item.tamanio === values.calibre,
          );

          if (selected_size && size_selected.total < palets_repartidos) {
            Swal.fire({
              icon: "info",
              title: "El total de cajas excede el limite en el calibre",
            });
            setFieldValue("cantidad_palet", 0);
            setRestante(0);
            return;
          }
        }
      }
      // if (resto < 0) {
      //   setFieldValue("cantidad_palet", 0);
      //   setRestante(0);
      //   return;
      // }
      setRestante(resto);
    }
  };

  const onVariedadSelect = (variedad) => {
    let selected_variedades = [...values.variedad_bicolor];
    const exists = values.variedad_bicolor.some(
      (item) => item.id_variedad === variedad.id_variedad,
    );
    if (exists) {
      selected_variedades = selected_variedades.filter(
        (item) => item.id_variedad !== variedad.id_variedad,
      );
    } else {
      selected_variedades.push(variedad);
    }
    if (selected_variedades.length === 0) {
      setFieldValue("id_tipo_etiqueta", 0);
      setFieldValue("id_peso_envase", 0);
      setFieldValue("id_tipo_caja", 0);
      setFieldValue("id_etiqueta", 0);
      setFieldValue("id_bultos_por_palet", 0);
      setFieldValue("bultos_por_palet", 0);
      setFieldValue("cantidad_palet", 0);
      setFieldValue("resto", false);
      setFieldValue("limite", 0);
    }
    setFieldValue("variedad_bicolor", selected_variedades);
  };

  const onSugerenciaClick = (sugerencia_id) => {
    const selectedSugerencia = sugerencias.find(
      (item) => item.id === sugerencia_id,
    );
    setSelectedSugerenciaId(sugerencia_id);
    if (selectedSugerencia) {
      setFieldValue("id_tipo_etiqueta", selectedSugerencia.tipo_etiqueta_id);
      setFieldValue("id_peso_envase", selectedSugerencia.peso_envase_id);
      setFieldValue("id_tipo_caja", selectedSugerencia.tipo_caja_id);
      setFieldValue("id_etiqueta", selectedSugerencia.etiquetas_id);
      setFieldValue("id_bultos_por_palet", selectedSugerencia.palet_id ?? 0);
      setFieldValue("bultos_por_palet", selectedSugerencia.bultos);
    }
  };

  return (
    <Modal isOpen={isVisible} toggle={onClose} size="xl">
      <ModalHeader toggle={onClose}>Empaque {values.variedad}</ModalHeader>
      <ModalBody>
        <TamanioOptions
          bicolor={values.bicolor}
          tamanios={tamaniosOptions}
          selectedSize={values.calibre}
          selectedVariedad={values.variedad_bicolor}
          variedadOptions={variedadOptions}
          onSizeClick={handleSelectSize}
          onVariedadClick={onVariedadSelect}
        />
        {values.calibre !== "" && sugerencias.length > 0 && !values.bicolor && (
          <div className="row">
            <div className="col-12">
              <label>Sugerencias</label>
              <hr />

              <div className="overflow-auto">
                <div className="d-flex gap-2 pb-2">
                  {sugerencias?.map((item) => {
                    const text = `${TIPO_ETIQUETA_SLUG[item.tipo_etiqueta] ?? item.tipo_etiqueta} - ${item.tipo_caja} - ${item.etiqueta} - ${item.bultos} BULTOS`;
                    return (
                      <button
                        key={item.id}
                        className={
                          selectedSugerenciaId === item.id
                            ? "btn btn-secondary"
                            : "btn btn-outline-secondary"
                        }
                        style={{
                          width: "150px",
                          height: "50px",
                          flexShrink: 0,
                        }}
                        onClick={() => onSugerenciaClick(item.id)}
                        title={item.alias === "" ? text : undefined}
                      >
                        {item.alias !== ""
                          ? item.alias
                          : `${text.slice(0, 10)}...`}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
        <br />
        <div className="row">
          <div className="col-6">
            <label>Tipo etiqueta</label>
            <hr />
            <Row>
              <TipoEtiquetaRender
                bicolor={values.bicolor}
                tipoEtiqueta={tipoEtiqueta}
                calibre={values.calibre}
                variedad={values.variedad_bicolor}
                selectedEtiqueta={values.id_tipo_etiqueta}
                setFieldValue={setFieldValue}
              />
            </Row>
          </div>
          <div className="col-6">
            <label>Peso de envase</label>
            <hr />
            <Row>
              {values.id_tipo_etiqueta !== 0 &&
                pesoEnvase.map((item) => (
                  <Col
                    className="d-grid mb-2"
                    md={3}
                    sm={2}
                    key={item.idtamano_envase}
                  >
                    <button
                      className={`btn btn-outline-success ${
                        values.id_peso_envase === item.idtamano_envase &&
                        "active"
                      }`}
                      onClick={() =>
                        handleSelectPesoEnvase(item.idtamano_envase)
                      }
                    >
                      {item.tamano}
                    </button>
                  </Col>
                ))}
            </Row>
          </div>
          <div className="col-6">
            <label>Tipo de caja</label>
            <hr />
            <Row>
              {values.id_peso_envase !== 0 &&
                tipoCaja.map((item) => (
                  <Col
                    md={4}
                    sm={12}
                    key={item.idenvase}
                    className="d-grid mb-2"
                  >
                    <button
                      className={`btn btn-outline-success ${
                        values.id_tipo_caja === item.idenvase && "active"
                      }`}
                      onClick={() => handleSelectTipoCaja(item.idenvase)}
                    >
                      {item.envase}
                    </button>
                  </Col>
                ))}
            </Row>
          </div>
          <div className="col-6">
            <label>Etiquetas</label>
            <hr />
            <Row>
              {values.id_tipo_caja !== 0 &&
                etiquetas.map((item) => (
                  <Col
                    sm={12}
                    md={4}
                    className="d-grid mb-2"
                    key={item.idrelacion}
                  >
                    <button
                      className={`btn btn-outline-success ${
                        values.id_etiqueta === item.idetiqueta && "active"
                      }`}
                      onClick={() => handleSelectEtiqueta(item.idetiqueta)}
                    >
                      {item.etiqueta}
                    </button>
                  </Col>
                ))}
            </Row>
          </div>
          <div className="col-6">
            <label>Bultos por palet</label>
            <br />
            {(errors.bultos_por_palet && touched.bultos_por_palet) !==
              undefined && (
              <label style={{ color: "red" }}>{errors.bultos_por_palet}</label>
            )}
            <hr />
            <Row>
              {values.id_etiqueta !== 0 &&
                butlosPalet.map((item) => (
                  <Col
                    sm={12}
                    md={4}
                    className="d-grid mb-2"
                    key={item.id_palet}
                  >
                    <button
                      className={`btn btn-outline-success ${
                        values.id_bultos_por_palet === item.id_palet && "active"
                      }`}
                      onClick={() =>
                        handleSelectBultosPorPalet(item.id_palet, item.palet)
                      }
                    >
                      {item.palet}
                    </button>
                  </Col>
                ))}
              {values.id_etiqueta !== 0 && (
                <Col sm={12} md={4} className="d-grid mb-2">
                  <button
                    className={`btn btn-outline-success ${
                      values.id_bultos_por_palet === 0 && "active"
                    }`}
                    onClick={() => handleSelectBultosPorPalet(0, 0)}
                  >
                    Otro
                  </button>
                </Col>
              )}
            </Row>
            {values.id_etiqueta !== 0 && values.id_bultos_por_palet === 0 && (
              <Row>
                <Col>
                  <input
                    className="form-control"
                    type="number"
                    value={values.bultos_por_palet}
                    onChange={handleChange}
                    name="bultos_por_palet"
                    placeholder="Otro"
                    onFocus={blurOnWheel}
                    min={0}
                  />
                </Col>
              </Row>
            )}
          </div>
          <div className="col-6">
            <div className="row">
              <div className={values.resto ? "col-6" : "col-12"}>
                <label>Cantidad palet</label>
                <br />
                {(errors.cantidad_palet && touched.cantidad_palet) !==
                  undefined && (
                  <label style={{ color: "red" }}>
                    {errors.cantidad_palet}
                  </label>
                )}
                <hr />
                <input
                  onFocus={blurOnWheel}
                  className="form-control"
                  type="number"
                  value={values.cantidad_palet}
                  name="cantidad_palet"
                  onChange={handleCantidadPaletChangeHandler}
                  min={0}
                  disabled={values.bultos_por_palet === 0 || values.resto}
                />
              </div>
              {values.resto && (
                <div className="col-6">
                  <label>Límite</label>
                  <br />
                  {(errors.limite && touched.limite) !== undefined && (
                    <label style={{ color: "red" }}>{errors.limite}</label>
                  )}
                  <hr />
                  <input
                    onFocus={blurOnWheel}
                    className="form-control"
                    value={values.limite}
                    onChange={handleChange}
                    name="limite"
                    min={0}
                  />
                </div>
              )}
              <div className="col-12">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={values.resto}
                  onChange={handleRestoChange}
                  name="resto"
                  disabled={values.bicolor || values.bultos_por_palet === 0}
                />{" "}
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Resto cosecha
                </label>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-12">
                <label>Resto: {restante}</label>
              </div>
            </div>
          </div>
          <div className="col-6">
            <label>Yeguere</label>
            <hr />
            <div className="row">
              {yeguere.map((item) => (
                <div className="col d-grid" key={item.idyeguere}>
                  <button
                    className={`btn btn-outline-success ${
                      values.id_yeguere === item.idyeguere && "active"
                    }`}
                    onClick={() => setFieldValue("id_yeguere", item.idyeguere)}
                  >
                    {item.yeguere}
                  </button>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-12">
                <label>Tipo de pedido</label>
                <hr />
                <div className="row">
                  {TIPO_PEDIDO.map((item) => (
                    <div className="col d-grid" key={item.tipo}>
                      <button
                        className={`btn btn-outline-success ${
                          values.tipo_pedido === item.tipo && "active"
                        } `}
                        onClick={() => setFieldValue("tipo_pedido", item.tipo)}
                      >
                        {item.tipo}
                      </button>
                    </div>
                  ))}
                </div>
                <br />
                <br />
                <div className="row">
                  <div className="col-12">
                    <label>Destino inmediato</label>
                    <hr />
                    <div className="row">
                      {destinoInmediato.map((item) => (
                        <div
                          className="col-md-4 col-sm-12 d-grid"
                          key={item.id_destino}
                        >
                          <button
                            className={`btn btn-outline-success ${
                              values.id_destino_inmediato === item.id_destino &&
                              "active"
                            }`}
                            onClick={() =>
                              setFieldValue(
                                "id_destino_inmediato",
                                item.id_destino,
                              )
                            }
                          >
                            {item.destino}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6">
            <label>Pais destino</label>
            <hr />
            <div className="row">
              {destino.map((item) => (
                <div
                  className="col-md-6 col-sm-12 d-grid mb-2"
                  key={item.iddestino}
                >
                  <button
                    className={`btn btn-outline-success ${
                      values.id_destino === item.iddestino && "active"
                    }`}
                    onClick={() => setFieldValue("id_destino", item.iddestino)}
                  >
                    {item.destino}
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="col-6">
            <label>Tarimas</label>
            <hr />
            <div className="row">
              {tarimas.map((item) => (
                <div key={item.idtarima} className="col d-grid">
                  <button
                    className={`btn btn-outline-success ${
                      values.id_tarima === item.idtarima && "active"
                    }`}
                    onClick={() => setFieldValue("id_tarima", item.idtarima)}
                  >
                    {item.tarima}
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="col-6">
            <label>Observaciones</label>
            <hr />
            <textarea
              className="form-control"
              rows="3"
              value={values.observaciones ?? ""}
              name="observaciones"
              onChange={handleChange}
            ></textarea>
            <br />
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={values.fumigar}
                onChange={handleChange}
                name="fumigar"
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                ¿Fumigar?
              </label>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-danger" onClick={onClose}>
          Cancelar
        </button>
        {!isEditing && (
          <button
            className="btn btn-primary"
            onClick={handleGuardarConPrioridadClick}
            type="button"
            disabled={isLoading}
          >
            {isLoading && <FontAwesomeIcon icon="fas fa-spinner" spin />}{" "}
            Guardar con prioridad
          </button>
        )}
        <button
          className="btn btn-success"
          onClick={handleSave}
          type="submit"
          disabled={isLoading}
        >
          {isLoading && <FontAwesomeIcon icon="fas fa-spinner" spin />} Guardar
        </button>
      </ModalFooter>
    </Modal>
  );
};

const TamanioOptions = ({
  bicolor,
  tamanios,
  selectedSize,
  selectedVariedad,
  variedadOptions,
  onSizeClick,
  onVariedadClick,
}) => {
  return (
    <>
      <div className="row">
        <div className="col-12 table-responsive">
          <table className="table">
            <thead>
              <tr>
                {tamanios.map((item) => (
                  <th key={item.tamanio}>
                    <button
                      className={`btn btn-outline-success ${
                        selectedSize === item.tamanio && "active"
                      }`}
                      onClick={() => onSizeClick(item.tamanio, item.total)}
                      style={{ width: "200px", textAlign: "center" }}
                    >
                      {item.tamanio}
                      <br />
                      {item.total}
                    </button>
                  </th>
                ))}
              </tr>
            </thead>
          </table>
        </div>
      </div>
      {bicolor && selectedSize !== "" && (
        <div className="row">
          <div className="col">
            <label>Variedades</label>
            <hr />
            <div className="row">
              {variedadOptions.map((item) => (
                <div className="col d-grid" key={item.id_variedad}>
                  <button
                    className={`btn btn-outline-success ${
                      selectedVariedad?.some(
                        (variedad) => variedad.id_variedad === item.id_variedad,
                      ) && "active"
                    }`}
                    onClick={() => onVariedadClick(item)}
                  >
                    <label>{item.variedad}</label>
                    <br />
                    <label>
                      {selectedSize !== "" &&
                        item.tamanios.find(
                          (tam) => tam.tamanio === selectedSize,
                        )?.total}
                    </label>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const TipoEtiquetaRender = ({
  tipoEtiqueta,
  bicolor,
  calibre,
  variedad,
  selectedEtiqueta,
  setFieldValue,
}) => {
  if (bicolor) {
    if (calibre !== "" && variedad.length > 0) {
      return tipoEtiqueta?.map((item) => (
        <Col className="d-grid" key={item.idtipo_etiqueta}>
          <button
            className={`btn btn-outline-success ${
              selectedEtiqueta === item.idtipo_etiqueta && "active"
            }`}
            onClick={() =>
              setFieldValue("id_tipo_etiqueta", item.idtipo_etiqueta)
            }
          >
            {item.etiqueta}
          </button>
        </Col>
      ));
    }
  } else {
    if (calibre !== "") {
      return tipoEtiqueta?.map((item) => (
        <Col className="d-grid" key={item.idtipo_etiqueta}>
          <button
            className={`btn btn-outline-success ${
              selectedEtiqueta === item.idtipo_etiqueta && "active"
            }`}
            onClick={() =>
              setFieldValue("id_tipo_etiqueta", item.idtipo_etiqueta)
            }
          >
            {item.etiqueta}
          </button>
        </Col>
      ));
    }
  }
  return null;
};

const blurOnWheel = (e) => {
  e.target.addEventListener("wheel", (event) => {
    if (event.target) {
      event.target.blur();
    }
  });
};
